import React from 'react';
import { ShieldCheckIcon, ZapIcon, UsersIcon, AwardIcon } from 'lucide-react';
export function TrustSignals() {
  const signals = [{
    icon: AwardIcon,
    text: 'Accredited Schools Only',
    detail: 'Quality programs you can trust'
  }, {
    icon: ZapIcon,
    text: 'Flexible and Convenient',
    detail: 'Study on your schedule'
  }, {
    icon: UsersIcon,
    text: '2M+ Students Matched',
    detail: 'Find your path forward'
  }, {
    icon: ShieldCheckIcon,
    text: 'Secure & Private',
    detail: 'Your information is safe'
  }];
  return <div className="w-full bg-background-alt border-b border-hairline py-6" data-id="element-842" data-mp="1759irdadryhc">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8" data-id="element-843" data-mp="1c54d5qtd7675">
        <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-5" data-id="element-844" data-mp="1c7gzsha2i4qj">
          {signals.map(signal => {
          const Icon = signal.icon;
          return <li key={signal.text} className="flex items-center gap-3 justify-center sm:justify-start text-center sm:text-left" data-id="element-845" data-mp="rim203y2uiz">
                <span className="p-2.5 bg-surface rounded-xl text-primary flex-shrink-0 ring-1 ring-inset ring-hairline" data-id="element-846" data-mp="ef3i0ct8vj07">
                  <Icon className="w-5 h-5" aria-hidden="true" data-id="element-847" data-mp="seusi3kjyh9g" />
                </span>
                <div className="min-w-0" data-id="element-848" data-mp="ncx28pdqim70">
                  <p className="text-sm font-semibold text-ink leading-tight" data-id="element-849" data-mp="12bqzu5ypsxcf">
                    {signal.text}
                  </p>
                  <p className="text-xs text-ink-secondary mt-0.5 leading-tight" data-id="element-850" data-mp="xbl86psg3auc">
                    {signal.detail}
                  </p>
                </div>
              </li>;
        })}
        </ul>
      </div>
    </div>;
}